import { COLOR_GRAY, COLOR_NEGATIVE_DARK, COLOR_PRIMARY } from '../colors.constants';

export const colorsIconButton = {
  colorIconButtonColor: COLOR_NEGATIVE_DARK,
  colorIconButtonBackground: COLOR_GRAY,
  colorIconButtonBackgroundHover: COLOR_PRIMARY,
};
